import axios from 'axios';
import { FilterClassificationModel } from '../Models/FilterClassificationModel';
import baseService from '../shared/baseService';

const categoryService = (classificationId: number) => 
    baseService(`classifications/${classificationId}/categories`);
    
const getCategoriesByFilters = (classificationId: number, filter: FilterClassificationModel) => 
    axios.post(`classifications/${classificationId}/categories/filters`, filter);

const deleteBatch = (ids: number[]) => axios.post('classifications/0/categories/delete-batch', ids);

export default {
    categoryService,
    getCategoriesByFilters,
    deleteBatch
};